import { useContext, useEffect } from 'react';

import { NavigationBarContext } from './NavigationBarContext';

export function useFixedNavBar() {
  const { setIsFixed } = useContext(NavigationBarContext);

  useEffect(() => {
    setIsFixed(true);

    return () => setIsFixed(false);
  }, []);
}
